module.exports = __webpack_public_path__ + "static/917337130.0ccc15cd.jpg";